/*
 * Fora de Disponibilidade.tsx porque a rota lê a lista no `validateSearch`,
 * que vai no chunk de entrada. Importada de lá, ela levava a tela inteira,
 * os pickers e o rrule junto para toda página, a sala da paciente inclusive.
 */
export const ABAS = ['semana', 'excecoes', 'fixo'] as const
export type Aba = (typeof ABAS)[number]
